import { createSlice } from "@reduxjs/toolkit";

const estadocuentaState = {
  dataestadocuenta: "",
}

export const estadocuentaSlice = createSlice({
  name: "estadocuenta",
  initialState: estadocuentaState,
  reducers: {
    StoreEstadoCuentaData: (state, actions) => {
      state.dataestadocuenta = actions.payload;
    },
    ResetEstadoCuentaData: () => estadocuentaState,
  }
});

export const { StoreEstadoCuentaData, ResetEstadoCuentaData } = estadocuentaSlice.actions;

export default estadocuentaSlice.reducer;